export class CustomAction{
    id: string;
    appId: string;
    actionName: string;
    param: string;
    script: string;
    stage: string;
    state: string;
    status: string;
    constructor(
        id:string = '', 
        appId:string = '',
        actionName: string = '',
        params: string = '',
        scriptPath: string = '',
        stage: string = '',
        state: string = '',
        status: string = ''
    ){
        this.id = id;
        this.appId = appId;
        this.actionName = actionName;
        this.param = params;
        this.script = scriptPath;
        this.stage = stage;
        this.state = state;
        this.status = status;
    }
}